import {
  userNeedsApprovalsStatsQueryKeys,
  userTaskStatsQueryKeys,
} from 'src/queries/queries.constants'
import { useExtendQuery } from 'src/queries/queries.utils'

export type GetTaskStatsResponse = {
  flaggedTransactionsCount: number
  missingReceiptsCount: number
  missingExpenseCategoriesCount: number
}

export const useQueryGetUserTaskStats = (enabled = true) => {
  return useExtendQuery<GetTaskStatsResponse, GetTaskStatsResponse>({
    queryKey: userTaskStatsQueryKeys.userTaskStats(),
    queryUrl: () => `/activities/statistics/missing`,
    enabled: enabled,
    retry: false,
  })
}

export type GetNeedsApprovalStatsResponse = {
  virtualCardsToApproveCount: number
  budgetsToApproveCount: number
  expensesToReviewCount: number
  reimbursementsToReviewCount: number
  managerReimbursementsToReviewCount: number
}

export const useQueryGetUserNeedsApprovalStats = (enabled = true) => {
  return useExtendQuery<
    GetNeedsApprovalStatsResponse,
    GetNeedsApprovalStatsResponse
  >({
    queryKey: userNeedsApprovalsStatsQueryKeys.userNeedsApprovalStats(),
    queryUrl: () => `/activities/statistics/approvals`,
    enabled: enabled,
    retry: false,
  })
}
